import { render, staticRenderFns } from "./self-assessment.vue?vue&type=template&id=6dcaf94e&"
import script from "./self-assessment.vue?vue&type=script&lang=js&"
export * from "./self-assessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports